
import { reducerConstants } from "../../../constants/reducer-constant";
import { INITIAL_STATE as referReducerInitialState, HANDLERS as referReducerHandler } from "../../../components/desktop/refer/reducers";

export default {
    [reducerConstants.REFER]: { state: referReducerInitialState, handler: referReducerHandler }
};
